export default __webpack_public_path__ + "static/our-story-e4bf1cdf0522365bd245b5de2699e4ed.webp";